<template>
  <div id="app_content" class="public">
    <div v-if="viewPort > 576" class="section top fp-section fp-table active fp-completely">
      <div class="section-container h-100">
        <div class="my-content h-100">
          <div class="container h-100 align-items-center d-flex">
            <div class="row w-100 align-items-center">
              <div class="col-md-12">
                <span class="breadcrumb-desktop mb-2"><a
                    href="/4-engeneering"><u>4-engineering</u></a>/{{ name }}</span>
              </div>
              <div class="col-xl-6 col-lg-9 order-2 order-lg-1">
                <eng_carousel class="eng-carousel" :carousel_items="images"/>
              </div>

              <div class="col-md-12 col-lg-3 order-1 order-lg-2 right">
                <span class="breadcrumb-mobile mb-2"><a href="/4-engeneering"><u>4-engineering</u></a>/{{ name }}</span>
                <h1 class="big text-green mb-3">{{ name }}</h1>
                <p>
                  {{ trans.get('public.banchi.subtitle') }}
                </p>
              </div>

              <div class="col-xl-9 col-lg-12 mt-5 order-3 order-lg-3">
                <h1>{{ name }}</h1>
                <p class="mt-3"></p>
                <a
                    class="d-flex text-green down align-items-center mt-5"
                    href="/downloads"
                >Download
                  <img
                      class="ml-2"
                      src="/media/icons/png/icons8-download-64-green.png"
                      alt=""
                  /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="section top fp-section fp-table active fp-completely">
      <div class="section-container mobile h-100">
        <div class="my-content h-100">
          <div class="container h-100 align-items-center d-flex is-flex-direction-column">
            <div class="row">
              <div class="col-md-12">
                <span class="breadcrumb-mobile mb-2"><a
                    href="/4-engeneering"><u>4-engineering</u></a>/{{ name }}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <h1 class="big text-green mb-3">{{ name }}</h1>
                <p>
                  {{ trans.get('public.banchi.subtitle') }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <eng_carousel class="eng-carousel" :carousel_items="images"/>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <h1>{{ name }}</h1>
                <p class="mt-3"></p>
                <a class="d-flex text-green down align-items-center mt-5"
                   href="/downloads">
                  Download
                  <img class="ml-2"
                       src="/media/icons/png/icons8-download-64-green.png"
                       alt=""/>
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="newsletter">
      <div class="section-wrapper">
        <div class="section-container">
          <form_newsletter_new/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import eng_carousel from "./eng-carousel";
import form_newsletter_new from "./../form-newsletter-new"

export default {
  components: {
    eng_carousel,
    form_newsletter_new
  },

  data: function () {
    return {
      name: this.$trans('public.banchi.name'),
      description:
          "",
      images: [
        "/media/vetrina/banchi.jpg",
      ],
      viewPort: null
    };
  },

  created: function () {
    this.viewPort = window.innerWidth
  },

  mounted: function () {
  },

  computed: {},

  methods: {},
};
</script>

<style lang="scss">
.right {
  margin: 15px 0;
  @media (min-width: 992px) {
    margin-bottom: unset;
  }
}

.big {
  font-size: 200%;
}

.down {
  img {
    width: 20px;
  }
}

/*
 * contenuto delle sezioni allineato togliendo l'ingombro
 * del menù
*/
#app_content {
  background-color: #25252a;
  font-size: 14px;

  p {
    text-align: justify;
  }
}

.inner-section.newsletter {
  width: 100vw;

  &.newsletter {
    background-color: #0e0e0e;
    margin-top: auto;
  }

  .my-content > div {
    padding: 0 20px;
    margin: 0 0 0 var(--public-menu-width);
  }
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: revert;
  font-weight: normal;
}

.section .section-container {
  max-width: calc(100% - var(--public-menu-width));
  margin: 0 0 0 var(--public-menu-width);

  .eng-carousel {
    margin-top: 20px;
  }
}

.section.top {
  padding: 0;
}

.inner-section {
}

.inner-top {
  height: 25vh;
  background-repeat: no-repeat;
  background-size: cover;
}

.inner-bottom {
  height: fit-content;
  padding: 2rem 0;
}

.row {
  max-width: 90%;
  width: 90%;
  justify-content: center;
}

.container {
  font-size: 1em;
  @media (min-width: 1921px){
    font-size: var(--font-size-large);
  }
  max-width: 100% !important;
  width: 100%;
}

.breadcrumb-desktop {
  display: block;
  @media (max-width: 576px) {
    display: none;
  }
}

.breadcrumb-mobile {
  display: none;
  @media (max-width: 576px) {
    display: block;
  }
}
.section-container.mobile {
  padding: 100px 0;
}
@media (min-width: 1921px) {
}

@media (min-width: 576px) {
  .inner-top {
    height: 50vh;
  }
  .inner-bottom {
    height: 50vh;
    padding: unset;
  }
}

@media screen and (max-width: 1220px) {
  .section .section-container {
    max-width: 95%;
    margin: auto;
  }
}

/*
 * payoff
*/
.payoff {
  font-size: 60px;
  font-weight: lighter;
}

@media screen and (max-width: 750px) {
  .payoff {
    font-size: 2.4em;
  }
}

@media screen and (max-width: 400px) {
  .payoff {
    font-size: 2em;
  }
}

.section.top,
.section.bgi {
  width: 100%;
  height: 100vh;
  color: white;
  background-repeat: no-repeat;
  background-origin: initial;
  background-clip: initial;
  background-size: cover;
  background-position: initial;
}

.section.bgi {
  background-size: contain;
}

.section-sub {
  display: flex;
  align-items: center;
  justify-content: center;
}

.section.std {
  width: 100%;
  height: 100vh;
  background-color: var(--black-2);
}

.section.top .content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.section.top .content h1 {
  font-size: 60px;
  font-weight: lighter;
}

#app-scroll
> div.section.top.fp-section.active.fp-table.fp-completely
> div
> div
> div
> div
> img {
  width: 420px;
  height: 130px;
}

.section.top .fp-tableCell {
  // width: calc(100vw - 250px);
  height: 100% !important;
  float: right;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.section.top {
  height: 100vh !important;

  .section-container-center-mode {
    height: 100%;
    display: flex;
    align-items: center;
  }

  .discover-button {
    margin-top: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .discover-text {
      display: inline-block;
      margin-bottom: 20px;
    }
  }
}

.section.std .content .text {
  color: white;
  width: 100%;
  max-width: 95%;
  width: 760px;
  margin: auto;
}

.section.std .content .text h1 {
  font-weight: 500;
}

.section.std .content .text p {
  margin: 0;
  font-weight: 300;
  color: var(--text-white);
}

.content-gallery {
  width: 100%;
  margin: auto;
  position: relative;
}

.content-gallery .slick-slider {
  margin-left: -180px;
}

.content-source-media {
  width: auto;
}

.content-source-media .source {
  width: inherit;
}

.content-source-media .source img {
  display: block;
  width: inherit;
  padding: 2em;
  transition: padding 0.2s 0.2s ease-in-out;
}

.slick-slide[aria-hidden="false"]:not(.slick-current) .source img {
  opacity: 0.4;
}

.slick-slide[aria-hidden="true"] .source img {
  opacity: 0.1;
}

.slick-slide.slick-current {
  z-index: 2;
  position: relative;
}

.slick-slide.slick-current .source img {
  padding: 0;
  opacity: 1;
}

.slick-prev::before,
.slick-next::before {
  content: "";
}

.btn-circle.arrow {
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-circle.slick-prev {
  top: 110px;
  left: 70%;
}

.btn-circle.slick-next {
  bottom: 40px;
  left: 70%;
}

.btn-circle.arrow span {
  width: 48px;
  height: 22px;
  display: inline-block;
  position: absolute;
  background-repeat: no-repeat;
  background-origin: initial;
  background-clip: initial;
  background-size: 100% auto;
  background-position: center;
}

.btn-circle.slick-prev span {
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}

/* ---------------------------- */

.fp-tableCell {
  position: relative;
}

.section:not(.gallery) .content,
.section-sub .content {
  max-width: 98%;
  max-width: 760px;
  margin: auto;
  position: relative;
}

.section .wrapper-data {
  width: 100%;
  margin-top: 20px;
}

@media (min-width: 1200px) {
  .section.top .fp-tableCell {
    width: calc(100vw - 250px);
  }
}
</style>

